import { InfoCircleOutlined } from '@ant-design/icons';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Button, Divider, Space, Table, Typography } from 'antd';
import React from 'react';

import { PREFIX, SORT_EMPLOYEES_HEADER, U_KEY } from '@app/constants';

import { useSortEmployees } from '@pages/Employees/SortEmployees/hooks/useSortEmployees';

import { Row, SaveButton } from '@pages/Employees/SortEmployees/components';
import { adaptDataToTable } from '@pages/Employees/SortEmployees/utils/adaptDataToTable';

import '@pages/Employees/SortEmployees/styles/SortEmployees.desktop.scss';
import '@pages/Employees/SortEmployees/styles/SortEmployees.mobile.scss';

const { Text } = Typography;

export const SortEmployees: React.FC = () => {
  const {
    handleSortByName,
    employees,
    handleSortByPosition,
    onDragEnd,
    isLoading,
    branchName,
    saveEmployees,
    isSaving,
  } = useSortEmployees();

  return (
    <div className={`${PREFIX}sort-employees`}>
      <Space direction="vertical" size="large" className="main-space">
        <Space align="baseline">
          <InfoCircleOutlined />
          <Text data-testid="hint">
            В выбранном порядке исполнители будут отображаться в журнале записей
            и графике работы филиала "{branchName}". <br />
            Если вы хотите поменять порядок сортировки, то перетащите
            исполнителей вверх или вниз.
          </Text>
        </Space>

        <div className="button-container">
          <div className="action-button_container">
            <Button
              type="primary"
              ghost
              onClick={handleSortByName}
              data-testid="sort-alphabetically"
            >
              По алфавиту
            </Button>
            <Button
              type="primary"
              ghost
              onClick={handleSortByPosition}
              data-testid="sort-by-position"
            >
              По должности
            </Button>
          </div>

          <SaveButton saveEmployees={saveEmployees} isSaving={isSaving} />
        </div>

        <Divider style={{ margin: '0px' }} />

        <DndContext modifiers={[restrictToVerticalAxis]} onDragEnd={onDragEnd}>
          <SortableContext
            items={employees.map((i) => i.Key)}
            strategy={verticalListSortingStrategy}
          >
            <Table
              loading={isLoading}
              className={'sort-employee_table employee-item'}
              components={{
                body: {
                  row: Row,
                },
              }}
              columns={SORT_EMPLOYEES_HEADER}
              dataSource={adaptDataToTable(employees)}
              rowKey={(record) => String(record[U_KEY])}
              pagination={false}
            />
          </SortableContext>
        </DndContext>

        <SaveButton saveEmployees={saveEmployees} isSaving={isSaving} />
      </Space>
    </div>
  );
};
